var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "debtors-list" },
    _vm._l(_vm.debtors, function (debtor) {
      return _c(
        "div",
        {
          key: debtor.debtorIndex,
          staticClass: "debtor-item card-item debtors-card-shadow",
          attrs: { id: `debtor-${debtor.debtorIndex}` },
        },
        [
          _c(
            "div",
            { staticClass: "debtor-header" },
            [
              debtor.type === "CODEBTOR"
                ? _c(
                    "a",
                    {
                      attrs: {
                        id: `delete-codebtor-${debtor.debtorIndex}`,
                        href: "#",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit(
                            "delete-codebtor",
                            debtor.debtorIndex
                          )
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa-solid fa-trash-can" })]
                  )
                : _c("div"),
              _vm.debtorIndexBeingChanged !== debtor.debtorIndex
                ? _c("div", { staticClass: "debtor-header-id-number" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          debtor.debtorIndex === 0
                            ? "Deudor"
                            : `Codeudor ${
                                debtor.idNumber || debtor.debtorIndex
                              }`
                        )
                      ),
                    ]),
                    debtor.type === "CODEBTOR"
                      ? _c(
                          "a",
                          {
                            attrs: { id: "codebtor-pen-button", href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changeCodebtorIdNumber(
                                  debtor.debtorIndex
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa-solid fa-pen" })]
                        )
                      : _vm._e(),
                  ])
                : _c(
                    "b-field",
                    {
                      attrs: {
                        id: "codebtor-dni-input",
                        type: _vm.validIdNumber ? "is-success" : "is-danger",
                        message: _vm.messageIdNumber,
                      },
                    },
                    [
                      _c("b-input", {
                        attrs: {
                          "icon-clickable": "",
                          placeholder: "RUT del codeudor",
                          size: "is-small",
                          rounded: "",
                        },
                        model: {
                          value: _vm.idNumber,
                          callback: function ($$v) {
                            _vm.idNumber = $$v
                          },
                          expression: "idNumber",
                        },
                      }),
                    ],
                    1
                  ),
              _c("div", { staticClass: "debtor-header-buttons" }, [
                debtor.type === "CODEBTOR" &&
                _vm.debtorIndexBeingChanged === debtor.debtorIndex
                  ? _c("div", { staticClass: "input-types" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-button-secondary is-rounded",
                          class:
                            _vm.extendedDebtor === debtor.debtorIndex &&
                            _vm.inputType === "incomes"
                              ? "is-primary"
                              : "",
                          attrs: { id: "codebtor-dni-save-button" },
                          on: {
                            click: function ($event) {
                              return _vm.saveChangedIdNumber(
                                _vm.idNumber,
                                debtor.debtorIndex
                              )
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s("Guardar"))])]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-button-secondary is-rounded",
                          class:
                            _vm.extendedDebtor === debtor.debtorIndex &&
                            _vm.inputType === "debts"
                              ? "is-primary"
                              : "",
                          attrs: { id: "codebtor-dni-cancel-button" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelChangedIdNumber()
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s("Cancelar"))])]
                      ),
                    ])
                  : _vm._e(),
                _vm.debtorIndexBeingChanged !== debtor.debtorIndex
                  ? _c("div", { staticClass: "input-types" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-button-secondary is-rounded",
                          class:
                            _vm.extendedDebtor === debtor.debtorIndex &&
                            _vm.inputType === "incomes"
                              ? "is-primary"
                              : "",
                          attrs: { id: "income-menu-button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("set-extended-debtor", {
                                debtorIndex: debtor.debtorIndex,
                                inputType: "incomes",
                              })
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("incomesText")))])]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-button-secondary is-rounded",
                          class:
                            _vm.extendedDebtor === debtor.debtorIndex &&
                            _vm.inputType === "debts"
                              ? "is-primary"
                              : "",
                          attrs: { id: "debt-menu-button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("set-extended-debtor", {
                                debtorIndex: debtor.debtorIndex,
                                inputType: "debts",
                              })
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("debtText")))])]
                      ),
                      _vm.featureToggleEligibilityButton
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "button is-button-secondary is-rounded",
                              class:
                                _vm.extendedDebtor === debtor.debtorIndex &&
                                _vm.inputType === "eligibility"
                                  ? "is-primary"
                                  : "",
                              attrs: { id: "eligibility-menu-button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("set-extended-debtor", {
                                    debtorIndex: debtor.debtorIndex,
                                    inputType: "eligibility",
                                  })
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("EligibilityText"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      debtor.type !== "CODEBTOR" && _vm.equifaxPdfLink
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "button is-button-secondary is-rounded",
                              class:
                                _vm.extendedDebtor === debtor.debtorIndex &&
                                _vm.inputType === "eligibility"
                                  ? "is-primary"
                                  : "",
                              attrs: {
                                id: "equifaxPdfLink",
                                href: _vm.equifaxPdfLink,
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("equifaxPdfLink"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "debtor-inputs transition-fast",
              class:
                _vm.extendedDebtor === debtor.debtorIndex ? "show" : "hide",
            },
            [
              _vm.inputType === "incomes"
                ? _c(
                    "div",
                    [
                      _c(
                        "IncomeInputs",
                        _vm._b(
                          {
                            attrs: { "debtor-index": debtor.debtorIndex },
                            on: {
                              "add-input": function ($event) {
                                return _vm.$emit("add-input", $event)
                              },
                              "delete-input": function ($event) {
                                return _vm.$emit("delete-input", $event)
                              },
                            },
                            model: {
                              value: _vm.debtors[debtor.debtorIndex].income,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.debtors[debtor.debtorIndex],
                                  "income",
                                  $$v
                                )
                              },
                              expression: "debtors[debtor.debtorIndex].income",
                            },
                          },
                          "IncomeInputs",
                          _vm.$attrs,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm.inputType === "debts"
                ? _c(
                    "div",
                    [
                      _c(
                        "DebtInputs",
                        _vm._b(
                          {
                            attrs: { "debtor-index": debtor.debtorIndex },
                            on: {
                              "add-input": function ($event) {
                                return _vm.$emit("add-input", $event)
                              },
                              "delete-input": function ($event) {
                                return _vm.$emit("delete-input", $event)
                              },
                            },
                            model: {
                              value: _vm.debtors[debtor.debtorIndex].debt,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.debtors[debtor.debtorIndex],
                                  "debt",
                                  $$v
                                )
                              },
                              expression: "debtors[debtor.debtorIndex].debt",
                            },
                          },
                          "DebtInputs",
                          _vm.$attrs,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm.inputType === "eligibility"
                ? _c(
                    "div",
                    [
                      _c("EligibilityInputs", {
                        attrs: { "debtor-index": debtor.debtorIndex },
                        on: {
                          "switch-eligibility-value": function ($event) {
                            return _vm.$emit("switch-eligibility-value", $event)
                          },
                        },
                        model: {
                          value: _vm.debtors[debtor.debtorIndex].eligibility,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.debtors[debtor.debtorIndex],
                              "eligibility",
                              $$v
                            )
                          },
                          expression: "debtors[debtor.debtorIndex].eligibility",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }